var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWinnersTopWaveDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1440 75"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#031E29",
  d: "M367.861 62.57C199.154 62.549 0 0 0 0v75h1440V62.57s-72-14.428-239.5 0-283.994-32.728-422-36.697-241.932 36.72-410.639 36.698"
})));
export default SvgWinnersTopWaveDesktop;